import React from 'react';
import AdditionalFeesItem from './AdditionalFeesItem';
import { Tables } from '../../../../Components';
import { TableActions } from '../../../../Enums';
import { actionTypes } from '../constants';
import { PaymentPlansLocalePath } from '../i18n/PaymentPlansLocale';

const AdditionalFees = ({ dispatch, fees }) => {
  const onActionClicked = (_enumKey, item) => {
    dispatch({
      value: item.id,
      action: actionTypes.REMOVE,
      nestedField: 'id',
      field: 'paymentPlanFees',
    });
  };
  return (
    <div>
      <AdditionalFeesItem dispatch={dispatch} />
      <Tables
        headerData={[
          { label: 'fee_type', input: 'feeType' },
          {
            label: 'amount',
            input: 'feeAmount',
            component: (row) =>
              row.isFixed ? `${row.feeAmount}` : `${row.feeAmount}%`,
          },
        ]}
        data={fees}
        bodyRowId={'fees'}
        activePage={1}
        defaultActions={[{ enum: TableActions.delete.key }]}
        actionsOptions={{ onActionClicked }}
        parentTranslationPath={PaymentPlansLocalePath}
      />
    </div>
  );
};

export default AdditionalFees;
